"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormLocalDateField = void 0;
const local_date_field_1 = require("../../../components/local-date-field/local-date-field");
const form_field_1 = require("./form-field");
exports.FormLocalDateField = form_field_1.formFieldFactory(local_date_field_1.LocalDateField);
//# sourceMappingURL=form-local-date-field.js.map